/* tslint:disable */
/* eslint-disable */
/**
 * Admin API
 * Internal Admin API
 *
 * The version of the OpenAPI document: 1.0.0
 * 
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */

import { mapValues } from '../runtime';
import type { GetLocationBrandCatalogs200ResponseLocationBrandsInnerCatalogAssignmentsValue } from './GetLocationBrandCatalogs200ResponseLocationBrandsInnerCatalogAssignmentsValue';
import {
    GetLocationBrandCatalogs200ResponseLocationBrandsInnerCatalogAssignmentsValueFromJSON,
    GetLocationBrandCatalogs200ResponseLocationBrandsInnerCatalogAssignmentsValueFromJSONTyped,
    GetLocationBrandCatalogs200ResponseLocationBrandsInnerCatalogAssignmentsValueToJSON,
    GetLocationBrandCatalogs200ResponseLocationBrandsInnerCatalogAssignmentsValueToJSONTyped,
} from './GetLocationBrandCatalogs200ResponseLocationBrandsInnerCatalogAssignmentsValue';

/**
 * 
 * @export
 * @interface GetLocationBrandCatalogs200ResponseLocationBrandsInner
 */
export interface GetLocationBrandCatalogs200ResponseLocationBrandsInner {
    [key: string]: any | any;
    /**
     * 
     * @type {string}
     * @memberof GetLocationBrandCatalogs200ResponseLocationBrandsInner
     */
    id: string;
    /**
     * 
     * @type {string}
     * @memberof GetLocationBrandCatalogs200ResponseLocationBrandsInner
     */
    name: string;
    /**
     * 
     * @type {boolean}
     * @memberof GetLocationBrandCatalogs200ResponseLocationBrandsInner
     */
    enabled: boolean;
    /**
     * 
     * @type {{ [key: string]: GetLocationBrandCatalogs200ResponseLocationBrandsInnerCatalogAssignmentsValue; }}
     * @memberof GetLocationBrandCatalogs200ResponseLocationBrandsInner
     */
    catalogAssignments?: { [key: string]: GetLocationBrandCatalogs200ResponseLocationBrandsInnerCatalogAssignmentsValue; };
}

/**
 * Check if a given object implements the GetLocationBrandCatalogs200ResponseLocationBrandsInner interface.
 */
export function instanceOfGetLocationBrandCatalogs200ResponseLocationBrandsInner(value: object): value is GetLocationBrandCatalogs200ResponseLocationBrandsInner {
    if (!('id' in value) || value['id'] === undefined) return false;
    if (!('name' in value) || value['name'] === undefined) return false;
    if (!('enabled' in value) || value['enabled'] === undefined) return false;
    return true;
}

export function GetLocationBrandCatalogs200ResponseLocationBrandsInnerFromJSON(json: any): GetLocationBrandCatalogs200ResponseLocationBrandsInner {
    return GetLocationBrandCatalogs200ResponseLocationBrandsInnerFromJSONTyped(json, false);
}

export function GetLocationBrandCatalogs200ResponseLocationBrandsInnerFromJSONTyped(json: any, ignoreDiscriminator: boolean): GetLocationBrandCatalogs200ResponseLocationBrandsInner {
    if (json == null) {
        return json;
    }
    return {
        
            ...json,
        'id': json['id'],
        'name': json['name'],
        'enabled': json['enabled'],
        'catalogAssignments': json['catalogAssignments'] == null ? undefined : (mapValues(json['catalogAssignments'], GetLocationBrandCatalogs200ResponseLocationBrandsInnerCatalogAssignmentsValueFromJSON)),
    };
}

export function GetLocationBrandCatalogs200ResponseLocationBrandsInnerToJSON(json: any): GetLocationBrandCatalogs200ResponseLocationBrandsInner {
    return GetLocationBrandCatalogs200ResponseLocationBrandsInnerToJSONTyped(json, false);
}

export function GetLocationBrandCatalogs200ResponseLocationBrandsInnerToJSONTyped(value?: GetLocationBrandCatalogs200ResponseLocationBrandsInner | null, ignoreDiscriminator: boolean = false): any {
    if (value == null) {
        return value;
    }

    return {
        
            ...value,
        'id': value['id'],
        'name': value['name'],
        'enabled': value['enabled'],
        'catalogAssignments': value['catalogAssignments'] == null ? undefined : (mapValues(value['catalogAssignments'], GetLocationBrandCatalogs200ResponseLocationBrandsInnerCatalogAssignmentsValueToJSON)),
    };
}

